import React from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useUsers } from 'hooks';
import { DocumentsList } from 'components';
import { getFormattedDateTime } from 'utils';
import { UserProfile } from 'types';

import { UsersListActionsCell } from './UsersListActionsCell';

const columns: GridColDef<UserProfile>[] = [
  {
    field: 'name',
    headerName: 'Name',
    minWidth: 120,
    flex: 0.4,
    valueGetter: (_, row) => `${row.firstName} ${row.lastName}`,
  },
  {
    field: 'companyName',
    headerName: 'Company name',
    minWidth: 60,
    flex: 0.2,
  },
  {
    field: 'email',
    headerName: 'Email',
    minWidth: 60,
    flex: 0.25,
  },
  {
    field: 'isBexio',
    headerName: 'Bexio',
    minWidth: 40,
    flex: 0.1,
    renderCell: (params) => (params.value ? '✓' : ''),
    align: 'center',
  },
  {
    field: 'isAdministrator',
    headerName: 'Admin',
    minWidth: 40,
    flex: 0.13,
    renderCell: (params) => (params.value ? '✓' : ''),
    align: 'center',
  },
  {
    field: 'createdAt',
    headerName: 'Joined At',
    minWidth: 60,
    flex: 0.2,
    valueFormatter: (value) => getFormattedDateTime(value),
  },
  {
    field: 'id',
    headerName: 'Actions',
    renderCell: (cellProps) => <UsersListActionsCell cellProps={cellProps} />,
    sortable: false,
    filterable: false,
  },
];

export const UsersList = () => {
  const { usersListQuery } = useUsers();

  const users = usersListQuery.data?.users ?? [];

  return (
    <DocumentsList
      rows={users}
      columns={columns}
      isLoading={usersListQuery.isLoading}
      storageKey={'allUsers'}
      rowHeight={45}
      initialSortModel={[
        {
          field: 'createdAt',
          sort: 'desc',
        },
      ]}
    />
  );
};
